var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"splashscreen"},[_c('div',{staticClass:"splashscreen-wrapper"},[_c('span',{staticClass:"splashscreen-text"},[_vm._v(" Trwa ładowanie danych… ")])])])
}]

export { render, staticRenderFns }